<app-nav-bar></app-nav-bar>
<app-loader [fullscreen]="true"></app-loader>
<app-popup></app-popup>
<router-outlet />